import { useAuth } from '@clerk/clerk-react';
import { isAdminOrgRole } from '@/lib/roles';

/**
 * useIsAdmin returns true when the current session's Clerk org role is admin
 * ("admin" or "org:admin"). Used to hide/route-guard the analytics/finance
 * surfaces the owner-only mobile-management app consumes (issue #906) — the
 * server (RequireAdmin) is the real boundary; this is UX/defense-in-depth so
 * non-admins never hit a broken/403 tab.
 */
export function useIsAdmin(): boolean {
  const { orgRole } = useAuth();
  return isAdminOrgRole(orgRole);
}
